import React, { ReactElement } from 'react'

import { Col, PageHeader, Row } from 'antd'

const ModalAjuda = (): ReactElement => {
  return (
    <PageHeader ghost={false} title="Ajuda">
      <Row>
        <Col span={24}>
          <div style={{ fontSize: '16px' }}>
            <span style={{ fontWeight: 'bold' }}>Informações de login: </span>O
            login deve ser feito em um dispositivo por vez. Caso seja feito
            login em outro dispositivo (seja site ou aplicativo móvel) com o
            mesmo CPF, o acesso anterior perderá a sessão devido ao uso do
            Token. Cada login é único. Não é permitido login com mesmo usuário
            simultaneamente em Site e APP.
            <br />
            <br />
            <span style={{ fontWeight: 'bold' }}>
              Agendamento de candidatos:{' '}
            </span>
            O processo de agendamento é iniciado via site. O usuário deverá
            efetuar a liberação de Agenda para a data desejada em Configurações:
            <br />
            → Escolher o armazém
            <br />
            → Opção liberar agenda e após efetuar via site a importação de
            candidatos.
            <br />
            <br />
            <span style={{ fontWeight: 'bold' }}>
              Importação de candidatos:{' '}
            </span>
            Deverá ser feito Download do modelo de referência que se encontra na
            tela “Importar” e utilizar o mesmo para importação. OBS: Não devem
            ser importadas viagens para o mesmo veículo no mesmo horário de
            previsão. O sistema faz a verificação se há duplicados para o mesmo
            horário, não importando e avisando o usuário as linhas não
            importadas caso haja.
            <br />
            <br />
            <span style={{ fontWeight: 'bold' }}>
              Criação de candidato manual:{' '}
            </span>
            Abrirá uma tela que terá um botão nessa tela para inserir de forma
            manual. A tela funciona através do campo de seleção de empresa e
            motoristas, onde é feita a busca diretamente no banco de dados e
            caso Empresa e Motorista não existam na seleção, deverá ser criado
            pelos menus CADASTRO-EMPRESA e CADASTRO-MOTORISTA.
            <br />
            <br />
            <span style={{ fontWeight: 'bold' }}>Exclusão de candidato: </span>
            Os candidatos podem ser excluídos manualmente um a um. A exclusão
            manual somente permite fazer isso no armazém que está aberto em
            tela.
            <br />
            <br />
            <span style={{ fontWeight: 'bold' }}>Edição de armazém: </span>
            A edição apenas será possível se não houver agenda liberada para
            aquela data.
            <br />
            <br />
            <span style={{ fontWeight: 'bold' }}>
              Utilização do aplicativo:{' '}
            </span>
            O aplicativo serve como auxiliar ao fluxo de operação do sistema.
            Para gerenciamento via celular, deverá primeiramente ser liberada
            agenda e feito a importação dos candidatos via site para
            agendamento.
            <br />
            <br />
            <span style={{ fontWeight: 'bold' }}>
              Alterações do status de agendamento:
            </span>
            <br />
            1. As lacunas da Grid de Agendamento são criadas por padrão com o
            status LIVRE; As lacunas no status Livre podem receber agendamentos,
            bloquear e reservar;
            <br />
            2. Deve ser possível selecionar uma ou várias lacunas e definir o
            status BLOQUEADO; As lacunas no status Bloqueado não podem receber
            agendamentos e nenhuma outra ação, apenas a ação de liberar agenda,
            para poderem voltar a ser utilizáveis primeiro é necessário liberar
            a lacuna de maneira que ela volte para o status Livre;
            <br />
            3. Deve ser possível selecionar de uma a três lacunas LIVRES
            consecutivas da mesma doca para RESERVAR; Para uma lacuna RESERVADA
            devem ser possíveis as ações: Aprovar, Cancelar, Alterar Horário,
            Ver Detalhes, Chat e Macros. Obs: não deve ser possível pular
            horário, ou selecionar horários de docas diferentes.
            <br />
            4. Uma vez APROVADO o agendamento de uma coluna devem ser possíveis
            as ações: Cancelar, Não compareceu, Alterar Horário, Ver Detalhes,
            Chat e Macro.
            <br />
            5. Uma vez NÃO COMPARECEU o agendamento de uma coluna devem ser
            possíveis as ações: Ver Detalhes, Chat e Macro.
            <br />
            <br />
            <span style={{ fontWeight: 'bold' }}>
              Regras de mudança de status do sistema:
            </span>
            <br />
            → Regra geral: nenhum Agendamento pode ser Reservado ou Aprovado ou
            Alterado ou Cancelado em horários anteriores ao atual.
            <br />
            → Uma alteração de horário só pode ocorrer para horários do futuro
            em relação à hora atual.
            <br />
            → Macros e chat podem ser gerados para agendas do passado.
            <br />
            → O Status No-Show somente pode ser alterado em horários anteriores
            ao atual.
            <br />→ O Status Cancelar faz com que o Candidato ou a Viagem volte
            para a lista para ser novamente agendado. Isto também ocorre para
            quando é marcado o Status No-Show, pois como ele não compareceu, ele
            volta para a lista para ser agendado novamente.
          </div>
        </Col>
      </Row>
    </PageHeader>
  )
}

export default ModalAjuda
